import React from 'react';

export function LeftTriangle() {
  return (
    <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="6" height="14" fill="#DADADA" />
      <g id="Price component">
        <path
          d="M-3883 -5023C-3883 -5024.1 -3882.1 -5025 -3881 -5025H4039C4040.1 -5025 4041 -5024.1 4041 -5023V2310C4041 2311.1 4040.1 2312 4039 2312H-3881C-3882.1 2312 -3883 2311.1 -3883 2310V-5023Z"
          fill="#EDEDED"
        />
        <g id="Desktop web" clipPath="url(#clip0_1974_16255)">
          <g id="Product card/Web">
            <g clipPath="url(#clip1_1974_16255)">
              <rect x="-73" y="-426" width="200" height="451" rx="8" fill="white" />
              <g id="Content">
                <g id="Product info">
                  <g id="Container">
                    <g id="Discout price">
                      <rect x="-65" y="-35" width="184" height="52" rx="8" fill="#F22643" />
                      <g id="Discount price">
                        <path d="M-65 -3H35C38.3137 -3 41 -0.313708 41 3V17H-65V-3Z" fill="#212124" />
                        <g id="Frame 427323306">
                          <path
                            d="M6 0H34C35.6569 0 37 1.34315 37 3V11C37 12.6569 35.6569 14 34 14H6V0Z"
                            fill="#F22643"
                          />
                          <path
                            id="Polygon 1"
                            d="M0.557821 7.65079C0.23683 7.2763 0.23683 6.7237 0.557821 6.34921L6 -2.62268e-07L6 14L0.557821 7.65079Z"
                            fill="#F22643"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          d="M-3881 -5024H4039V-5026H-3881V-5024ZM4040 -5023V2310H4042V-5023H4040ZM4039 2311H-3881V2313H4039V2311ZM-3882 2310V-5023H-3884V2310H-3882ZM-3881 2311C-3881.55 2311 -3882 2310.55 -3882 2310H-3884C-3884 2311.66 -3882.66 2313 -3881 2313V2311ZM4040 2310C4040 2310.55 4039.55 2311 4039 2311V2313C4040.66 2313 4042 2311.66 4042 2310H4040ZM4039 -5024C4039.55 -5024 4040 -5023.55 4040 -5023H4042C4042 -5024.66 4040.66 -5026 4039 -5026V-5024ZM-3881 -5026C-3882.66 -5026 -3884 -5024.66 -3884 -5023H-3882C-3882 -5023.55 -3881.55 -5024 -3881 -5024V-5026Z"
          fill="black"
          fillOpacity="0.1"
        />
      </g>
    </svg>
  );
}
